import * as React from "react";
import styled, { css } from "../../styled";
import { shadeAlternate } from "../../styled/helpers";
export const TimelineWrapper = styled("div") `
	background: ${({ theme }) => shadeAlternate(0.03, theme.box.background)};
	padding: 60px 40px 20px 40px;
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: space-between;
`;
export const TimelineConnector = styled("div") `
	height: 3px;
	width: 100%;
	background: ${({ theme }) => shadeAlternate(0.2, theme.box.background)};
	${({ active }) => !active ? "" : css `
		background: ${({ theme }) => theme.colors.primary};
	`};
`;
export const TimelineMarker = styled("div") `
	position: relative;
	height: 14px;
	width: 14px;
	min-width: 14px;
	border-radius: 50%;
	background: ${({ theme }) => shadeAlternate(0.2, theme.box.background)};
	${({ active }) => !active ? "" : css `
		background: ${({ theme }) => theme.colors.primary};
		.tl-label {
			display: flex;
			font-weight: 600;
			font-size: 14px;
		}
	`};
	${({ current }) => !current ? "" : css `
		.tl-label {
			display: flex;
			font-weight: 600;
			font-size: 14px;
		}
	`};
`;
export const TimelineMarkerLabel = styled("div") `
	position: absolute;
	top: -52px;
	left: 50%;
	display: flex;
	justify-content: space-around;
	align-items: center;
	transform: translateX(-50%);
	font-size: 14px;
	width: auto;
	min-width: 60px;
	height: 45px;
	text-align: center;
`;
export class Timeline extends React.Component {
    render() {
        const { stages, current } = this.props;
        const currentIndex = stages.findIndex((s) => s.id === current);
        return (React.createElement(TimelineWrapper, null, stages.map((s, i) => {
            return [
                i === 0 ? null : (React.createElement(TimelineConnector, { key: `${i}-connector`, active: i <= currentIndex })),
                (React.createElement(TimelineMarker, { key: `${i}-marker`, active: i <= currentIndex, current: i === currentIndex },
                    React.createElement(TimelineMarkerLabel, { className: "tl-label" }, s.label))),
            ];
        })));
    }
}
//# sourceMappingURL=index.js.map